/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaPricefactorgridData } from './aaa_pricefactorgrid.data';
import { IAaa_pricefactorgridProps } from './aaa_pricefactorgrid.props.autogenerated';
import {
    getBMAPriceFactorMatrixAsync,
    getBMAStockistAsync,
    updateBMAPriceFactorMatrixAsync
} from '../../dataActions/DataActionExtension.g';

export interface IAaa_pricefactorgridState {
    priceFactorsData: any;
    editMode: boolean;
    isPriceFactorAvailable: boolean;
}
export interface IAaa_pricefactorgridViewProps extends IAaa_pricefactorgridProps<IAaaPricefactorgridData> {
    handleChange: any;
    editMode: boolean;
    toggleEditMode: any;
    updatePriceFactor: any;
    priceFactors: any;
    isPriceFactorsNotAvailableText: string | undefined;
    isPriceFactorAvailable: boolean;
}

/**
 *
 * Aaa_pricefactorgrid component
 * @extends {React.PureComponent<IAaa_pricefactorgridProps<IAaa_pricefactorgridData>>}
 */
class Aaa_pricefactorgrid extends React.PureComponent<IAaa_pricefactorgridProps<IAaaPricefactorgridData>, IAaa_pricefactorgridState> {
    constructor(props: any) {
        super(props);
        this.state = {
            priceFactorsData: [],
            editMode: false,
            isPriceFactorAvailable: true
        };
    }
    public componentDidMount() {
        void this.getBMAPriceFactors();
    }
    private getBMAPriceFactors = async () => {
        const customerInfo: any = this.props.context.actionContext.requestContext.user;
        if (customerInfo.isAuthenticated) {
            const stockistInfo: any = await getBMAStockistAsync({ callerContext: this.props.context.actionContext });
            const data = await getBMAPriceFactorMatrixAsync(
                { callerContext: this.props.context.actionContext },
                stockistInfo.BMARetailStockist
            );
            let isPriceFactorAvailable = true;
            if (data.Result?.length === 0) {
                isPriceFactorAvailable = false;
            }
            this.setState({ priceFactorsData: data.Result, isPriceFactorAvailable });
        }
    };
    private handleChange = (index: number, dataType: string, value: any) => {
        // update table row....
        const newState = this.state.priceFactorsData.map((item: any, i: number) => {
            if (i === index) {
                return { ...item, [dataType]: value };
            }
            return item;
        });

        this.setState({
            priceFactorsData: newState
        });
    };
    private updatePriceFactor = async () => {
        // update table row....
        console.log(this.state.priceFactorsData);
        await updateBMAPriceFactorMatrixAsync({ callerContext: this.props.context.actionContext }, this.state.priceFactorsData);
        this.toggleEditMode();
    };
    private toggleEditMode = () => {
        // update table row....
        this.setState({
            editMode: !this.state.editMode
        });
    };
    public render(): JSX.Element | null {
        const viewProps: IAaa_pricefactorgridViewProps = {
            ...(this.props as IAaa_pricefactorgridProps<IAaaPricefactorgridData>),
            handleChange: this.handleChange,
            updatePriceFactor: this.updatePriceFactor,
            toggleEditMode: this.toggleEditMode,
            editMode: this.state.editMode,
            priceFactors: this.state.priceFactorsData,
            isPriceFactorsNotAvailableText: this.props.config.priceFactorsNotAvailableText
                ? this.props.config.priceFactorsNotAvailableText
                : '',
            isPriceFactorAvailable: this.state.isPriceFactorAvailable
        };
        return this.props.renderView(viewProps);
    }
}

export default Aaa_pricefactorgrid;
